import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="fixed h-full w-full bg-[#09090b] flex flex-col items-center justify-center p-8">
      <Helmet>
        <title>404 — ponchotang</title>
      </Helmet>
      <div className="w-72">
        <p className="text-zinc-400 text-xs tracking-widest uppercase mb-8">ponchotang</p>
        <p className="text-zinc-300 text-lg mb-2">404</p>
        <p className="text-zinc-500 text-sm mb-8">page not found</p>
        <Link to="/" className="text-zinc-400 text-sm hover:text-white transition-colors duration-150">
          ← back home
        </Link>
      </div>
    </div>
  );
}
